import { ReactNode, createContext, useContext, useState } from 'react';

type KalenderContext = {
  isScrolling: boolean;
  setIsScrolling: (value: boolean) => void;
};

const KalenderContext = createContext<KalenderContext>(null);

export function KalenderProvider({ children }: { children: ReactNode }) {
  const [isScrolling, setIsScrolling] = useState(false);
  const value = {
    isScrolling,
    setIsScrolling,
  };

  return (
    <KalenderContext.Provider value={value}>
      {children}
    </KalenderContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useKalenderContext() {
  const kalenderContext = useContext(KalenderContext);
  return kalenderContext;
}
